export default __webpack_public_path__ + "static/media/pocket-fm-logo.210b9675.webp";